@if (loading()) {
  <aux-table-skeleton />
} @else {
  <div class="mb-4 text-xl font-semibold">Adjustments to Prepaid</div>
  <aux-table-panel>
    <div class="flex items-center justify-between p-4">
      <div class="flex items-center space-x-2">
        @if (editMode()) {
          <aux-button
            variant="negative"
            label="Delete"
            icon="Trash"
            class="mr-2"
            [disabled]="!canDeleteSelected()"
            [auxTooltip]="!canDeleteSelected() ? 'Select at least 1 row to delete' : ''"
            (click)="onDeleteSelected()"
          />
        }
        <aux-button
          class="block flex-1"
          variant="hyperlink"
          (clickEmit)="clearAll()"
          label="Clear All"
        />
      </div>
      <div class="flex justify-end space-x-2">
        <aux-button
          variant="secondary"
          label="Adjustment"
          icon="CirclePlus"
          [onClick]="onAddAdjustment"
          [disabled]="isEditDisabled()"
          [auxTooltip]="prepaidLockTooltip()"
        />

        @if (editMode()) {
          <aux-button variant="secondary" label="Cancel" icon="X" [onClick]="onCancel" />

          <aux-button
            variant="success"
            label="Save"
            class="ml-1"
            icon="Check"
            [disabled]="!hasChanges()"
            [onClick]="onSaveAll"
          />
        } @else {
          <aux-button
            variant="secondary"
            label="Edit"
            icon="Pencil"
            [onClick]="onEdit"
            [disabled]="isEditDisabled()"
            [auxTooltip]="prepaidLockTooltip()"
          />
          <aux-export-excel-button
            classList="ml-1"
            [clickFN]="onExport.bind(this)"
            [spinnerSize]="7"
            pendoTag="prepaid-summary-excel-export-button"
          />
        }
      </div>
    </div>

    <ag-grid-angular
      domLayout="autoHeight"
      class="new-flat-theme unselectable prepaid-table w-full tabular-nums"
      [rowData]="gridData()"
      [gridOptions]="gridOptions()"
      [enableFillHandle]="editMode()"
      (gridReady)="onGridReady($event)"
      (filterChanged)="onFilterChanged()"
      (selectionChanged)="onSelectionChanged()"
      (sortChanged)="onSortChanged()"
      auxStickyGrid
    />
  </aux-table-panel>
}
